import clsx from 'clsx';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import './style.scss';

const NoProducts = ({variant, authentication, title: articleTitle}) => {
  const history = useHistory();
  const search = useLocation();
  const {t} = useTranslation();
  const handleGoTo = path => history.push(path);

  const renderNoProductInfo = (
    icon,
    firstTitle,
    withButtons = false,
    secondTitle,
  ) => {
    return (
      <>
        {icon}
        <h2 className="no__products-title">
          {firstTitle ?? ''}
          {!search.pathname.includes('product-groups')
            ? articleTitle
              ? ' ' + '"' + (articleTitle ?? '') + '"'
              : null
            : null}
          {secondTitle ?? null}
        </h2>
        {!withButtons && (
          <div className="no__products-btns">
            <button onClick={() => handleGoTo('/')} className="btn">
              {t('common:home')}
            </button>
            {firstTitle === t('common:no_products-cart') ? (
              authentication.loggedIn ? (
                <button
                  onClick={() => handleGoTo('/profile/orders')}
                  className="btn btn-outline">
                  {t('common:to_personal_account')}
                </button>
              ) : (
                <button
                  onClick={() => handleGoTo('/sign-in')}
                  className="btn btn-outline">
                  {t('common:come_in')}
                </button>
              )
            ) : (
              <button
                onClick={() => handleGoTo('/')}
                className="btn btn-outline">
                {t('common:search_for_products')}
              </button>
            )}
          </div>
        )}
      </>
    );
  };
  return (
    <div
      className={clsx(
        'no__products',
        variant === 'noReviews' || variant === 'noQuestions' ? 'mt-10' : '',
      )}>
      <div className="no__products-wrapper">
        {variant === 'catalogProducts' &&
          renderNoProductInfo(
            noCatalogProductIcon,
            t('common:no_product_text1'),
            false,
            t('common:no_product_text2'),
          )}
        {variant === 'cartProducts' &&
          renderNoProductInfo(noCartProductIcon, t('common:no_products-cart'))}
        {variant === 'favoruiteProducts' &&
          renderNoProductInfo(
            noFavoruitePrudctIcon,
            t('common:no_products-favoruite'),
          )}
        {variant === 'noReviews' &&
          renderNoProductInfo(noReviewsIcon, t('common:no_reviews'), true)}
        {variant === 'noQuestions' &&
          renderNoProductInfo(noQuestionsIcon, t('common:no_questions'), true)}
      </div>
    </div>
  );
};

const noQuestionsIcon = (
  <svg
    width="165"
    height="167"
    viewBox="0 0 165 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="13.125"
      cy="13.125"
      r="11.125"
      stroke="#FFBE00"
      strokeWidth="4"
    />
    <circle cx="161.5" cy="33.5" r="2.75" stroke="#FFBE00" strokeWidth="1.5" />
    <circle cx="12.5" cy="44.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="125.5" cy="163.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="42.5" cy="11.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <path
      d="M87.5026 160.416C127.773 160.416 160.419 127.77 160.419 87.4997C160.419 47.2289 127.773 14.583 87.5026 14.583C47.2318 14.583 14.5859 47.2289 14.5859 87.4997C14.5859 127.77 47.2318 160.416 87.5026 160.416Z"
      fill="#FFBE00"
      stroke="#FFBE00"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.125 114.023H91.625L73.2688 126.233C72.6493 126.646 71.9293 126.883 71.1856 126.919C70.442 126.955 69.7025 126.788 69.0462 126.437C68.3899 126.086 67.8412 125.562 67.4589 124.924C67.0765 124.285 66.8747 123.554 66.875 122.81V114.023C54.5 114.023 46.25 105.773 46.25 93.3984V68.6484C46.25 56.2734 54.5 48.0234 66.875 48.0234H108.125C120.5 48.0234 128.75 56.2734 128.75 68.6484V93.3984C128.75 105.773 120.5 114.023 108.125 114.023Z"
      stroke="#FFF5F5"
      strokeWidth="4"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M87.5037 84.8603V83.9941C87.5037 81.1891 89.2363 79.7041 90.9688 78.5078C92.66 77.3528 94.3512 75.8679 94.3512 73.1454C94.3512 69.3504 91.2987 66.2979 87.5037 66.2979C83.7087 66.2979 80.6562 69.3504 80.6562 73.1454M87.4831 94.7191H87.5244"
      stroke="#FFF5F5"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="153" cy="160" r="6" stroke="#FFBE00" strokeWidth="2" />
  </svg>
);

const noReviewsIcon = (
  <svg
    width="165"
    height="167"
    viewBox="0 0 165 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="13.125"
      cy="13.125"
      r="11.125"
      stroke="#FFBE00"
      strokeWidth="4"
    />
    <circle cx="161.5" cy="33.5" r="2.75" stroke="#FFBE00" strokeWidth="1.5" />
    <circle cx="12.5" cy="44.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="125.5" cy="163.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="42.5" cy="11.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <path
      d="M87.5026 160.416C127.773 160.416 160.419 127.77 160.419 87.4997C160.419 47.2289 127.773 14.583 87.5026 14.583C47.2318 14.583 14.5859 47.2289 14.5859 87.4997C14.5859 127.77 47.2318 160.416 87.5026 160.416Z"
      fill="#FFBE00"
      stroke="#FFBE00"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="80.8203"
      y="69.4749"
      width="27.6869"
      height="8.97475"
      rx="4.48737"
      transform="rotate(45 80.8203 69.4749)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="3.5"
    />
    <rect
      x="74.4749"
      y="89.0527"
      width="27.6869"
      height="8.97475"
      rx="4.48737"
      transform="rotate(-45 74.4749 89.0527)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="3.5"
    />
    <path
      d="M66.875 114.023H83.375L101.731 126.233C102.351 126.646 103.071 126.883 103.814 126.919C104.558 126.955 105.297 126.788 105.954 126.437C106.61 126.086 107.159 125.562 107.541 124.924C107.924 124.285 108.125 123.554 108.125 122.81V114.023C120.5 114.023 128.75 105.773 128.75 93.3984V68.6484C128.75 56.2734 120.5 48.0234 108.125 48.0234H66.875C54.5 48.0234 46.25 56.2734 46.25 68.6484V93.3984C46.25 105.773 54.5 114.023 66.875 114.023Z"
      stroke="white"
      strokeWidth="4"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="153" cy="160" r="6" stroke="#FFBE00" strokeWidth="2" />
  </svg>
);

const noCatalogProductIcon = (
  <svg
    width="165"
    height="167"
    viewBox="0 0 165 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="13.125"
      cy="13.125"
      r="11.125"
      stroke="#FFBE00"
      strokeWidth="4"
    />
    <circle cx="161.5" cy="33.5" r="2.75" stroke="#FFBE00" strokeWidth="1.5" />
    <circle cx="12.5" cy="44.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="125.5" cy="163.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="42.5" cy="11.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <path
      d="M87.5026 160.415C127.773 160.415 160.419 127.769 160.419 87.4987C160.419 47.2279 127.773 14.582 87.5026 14.582C47.2318 14.582 14.5859 47.2279 14.5859 87.4987C14.5859 127.769 47.2318 160.415 87.5026 160.415Z"
      fill="#FFBE00"
      stroke="#FFBE00"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.8665 116.026C103.531 115.506 117.429 100.765 116.909 83.1009C116.389 65.4368 101.648 51.5387 83.9837 52.0586C66.3196 52.5785 52.4215 67.3196 52.9414 84.9837C53.4613 102.648 68.2024 116.546 85.8665 116.026Z"
      stroke="white"
      strokeWidth="5"
      strokeLinejoin="round"
    />
    <path d="M107.32 106.906L122.079 121.997Z" fill="white" />
    <path
      d="M107.32 106.906L122.079 121.997"
      stroke="white"
      strokeWidth="3.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="78.9453"
      y="71.2893"
      width="27.6869"
      height="8.97475"
      rx="4.48737"
      transform="rotate(45 78.9453 71.2893)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="3.5"
    />
    <rect
      x="72.5999"
      y="90.8652"
      width="27.6869"
      height="8.97475"
      rx="4.48737"
      transform="rotate(-45 72.5999 90.8652)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="3.5"
    />
    <circle cx="153" cy="160" r="6" stroke="#FFBE00" strokeWidth="2" />
  </svg>
);
const noCartProductIcon = (
  <svg
    width="165"
    height="167"
    viewBox="0 0 165 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="13.125"
      cy="13.125"
      r="11.125"
      stroke="#FFBE00"
      strokeWidth="4"
    />
    <circle cx="161.5" cy="33.5" r="2.75" stroke="#FFBE00" strokeWidth="1.5" />
    <circle cx="12.5" cy="44.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="125.5" cy="163.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="42.5" cy="11.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <path
      d="M87.5026 160.415C127.773 160.415 160.419 127.769 160.419 87.4987C160.419 47.2279 127.773 14.582 87.5026 14.582C47.2318 14.582 14.5859 47.2279 14.5859 87.4987C14.5859 127.769 47.2318 160.415 87.5026 160.415Z"
      fill="#FFBE00"
      stroke="#FFBE00"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.8829 55.2586L51.8911 55.2505L51.8992 55.2422C52.4585 54.6698 53.2741 54.3424 54.0945 54.3538L54.0945 54.3539H54.1084C57.175 54.3539 60.2485 54.9944 62.7187 56.6438L62.7187 56.6438L62.7227 56.6464C64.6315 57.9077 66.0997 59.8127 66.9433 61.9704L66.9465 61.9788L66.95 61.9871C67.4024 63.0854 67.6732 64.2683 67.9186 65.5237L67.919 65.526C68.0968 66.4241 68.2745 67.3223 68.4522 68.2205C70.0127 76.1077 71.5741 84.0001 73.1951 91.8804L73.1951 91.8804L73.1973 91.8907C73.5262 93.4085 74.3434 94.9628 75.7578 95.9307C77.3409 97.0687 79.2788 97.4229 81.0326 97.423C83.9057 97.4265 86.7759 97.4253 89.6453 97.4242C93.5693 97.4226 97.4916 97.421 101.417 97.4312L101.877 97.4324L102.177 97.0843C103.394 95.6731 104.368 94.0966 105.285 92.5974C106.546 90.5514 107.68 88.4299 108.795 86.341C109.003 85.9528 109.21 85.5656 109.417 85.1803C110.216 83.7226 110.974 82.1742 111.72 80.6513C112.257 79.5537 112.788 78.4693 113.323 77.4415C113.91 76.3372 115.288 75.6955 116.522 75.9499L116.537 75.9529L116.552 75.9555C117.901 76.1919 118.991 77.4926 119 78.8763V79.0617C118.948 79.5391 118.809 80.0104 118.595 80.452L118.593 80.4567C116.051 85.7777 113.448 91.0358 110.371 96.0079C109.049 98.0879 107.712 100.079 106.05 101.758C105.014 102.787 103.939 103.514 102.8 103.488L102.787 103.488L102.774 103.488C97.7702 103.504 92.7666 103.501 87.7611 103.498C85.5163 103.497 83.2712 103.496 81.0254 103.496L81.0235 103.496C77.9539 103.503 74.8785 102.711 72.4082 100.985L72.4083 100.985L72.3987 100.978C69.7828 99.1943 67.9377 96.3385 67.2727 93.2231C65.7803 86.0285 64.3535 78.8216 62.9256 71.609C62.5667 69.7965 62.2078 67.9836 61.8478 66.1705C61.6209 64.9949 61.2395 63.5689 60.2222 62.4748C59.1739 61.3187 57.6955 60.8226 56.3998 60.6135C55.8287 60.5016 55.2121 60.4768 54.6954 60.456C54.5378 60.4496 54.3896 60.4437 54.2547 60.4357C53.6092 60.3977 53.119 60.318 52.6988 60.0974L52.6848 60.0901L52.6706 60.0832C51.7153 59.6195 51.0538 58.5836 51 57.4914V57.2502C51.0652 56.4753 51.3748 55.755 51.8829 55.2586Z"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="2"
    />
    <path
      d="M77.1895 108.301L77.1895 108.301L77.1989 108.3C78.5704 108.016 80.0589 108.323 81.2933 109.075C82.4999 109.836 83.4158 111.05 83.7716 112.412L83.7769 112.432L83.7829 112.451C84.5077 114.82 83.3237 117.638 81.1453 118.854L81.1376 118.859L81.13 118.863C79.8116 119.63 78.1956 119.873 76.79 119.437L76.7693 119.43L76.7484 119.425C75.3627 119.06 74.1285 118.119 73.3824 116.881L73.382 116.881C72.5492 115.502 72.2945 113.782 72.7946 112.313L72.8031 112.288L72.8102 112.262C73.3699 110.282 75.1464 108.703 77.1895 108.301Z"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="2"
    />
    <path
      d="M105.361 108.984L105.368 108.989L105.376 108.993C107.599 110.237 108.778 113.137 107.971 115.532L107.962 115.558L107.955 115.585C107.307 117.923 104.945 119.668 102.505 119.649L102.501 119.649C100.899 119.643 99.2967 118.926 98.2436 117.73L98.2437 117.73L98.237 117.722C97.1799 116.546 96.6376 114.911 96.8027 113.347C96.9724 111.854 97.725 110.434 98.8793 109.513L98.894 109.502L98.9083 109.489C99.5832 108.908 100.455 108.529 101.412 108.302C102.735 108.028 104.17 108.29 105.361 108.984Z"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="2"
    />
    <rect
      x="86.9219"
      y="68.8361"
      width="19.875"
      height="6.75"
      rx="3.375"
      transform="rotate(45 86.9219 68.8361)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="2"
    />
    <rect
      x="82.1486"
      y="82.8906"
      width="19.875"
      height="6.75"
      rx="3.375"
      transform="rotate(-45 82.1486 82.8906)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="2"
    />
    <circle cx="153" cy="160" r="6" stroke="#FFBE00" strokeWidth="2" />
  </svg>
);
const noFavoruitePrudctIcon = (
  <svg
    width="165"
    height="167"
    viewBox="0 0 165 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="13.125"
      cy="13.125"
      r="11.125"
      stroke="#FFBE00"
      strokeWidth="4"
    />
    <circle cx="161.5" cy="33.5" r="2.75" stroke="#FFBE00" strokeWidth="1.5" />
    <circle cx="12.5" cy="44.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="125.5" cy="163.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <circle cx="42.5" cy="11.5" r="2.5" stroke="#FFBE00" strokeWidth="2" />
    <path
      d="M87.5026 160.415C127.773 160.415 160.419 127.769 160.419 87.4987C160.419 47.2279 127.773 14.582 87.5026 14.582C47.2318 14.582 14.5859 47.2279 14.5859 87.4987C14.5859 127.769 47.2318 160.415 87.5026 160.415Z"
      fill="#FFBE00"
      stroke="#FFBE00"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="80.8203"
      y="76.4749"
      width="27.6869"
      height="8.97475"
      rx="4.48737"
      transform="rotate(45 80.8203 76.4749)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="3.5"
    />
    <rect
      x="74.4749"
      y="96.0527"
      width="27.6869"
      height="8.97475"
      rx="4.48737"
      transform="rotate(-45 74.4749 96.0527)"
      fill="white"
      stroke="#FFBE00"
      strokeWidth="3.5"
    />
    <path
      d="M50.364 76.6356C48.1315 64.5233 56.3819 54.0313 69.2428 53.0403C80.5668 52.1751 86.1803 65.5144 87.3127 68.0627C87.3253 68.1054 87.3518 68.143 87.3883 68.1697C87.4248 68.1965 87.4692 68.211 87.5149 68.211C87.5606 68.211 87.6051 68.1965 87.6416 68.1697C87.6781 68.143 87.7046 68.1054 87.7172 68.0627C92.9747 54.047 102.552 53.4492 105.917 53.1189C114.976 52.1751 127.125 58.9863 124.682 74.8581C121.188 96.8805 87.2804 121.75 87.2804 121.75C87.2804 121.75 54.7804 100.31 50.364 76.6356Z"
      stroke="white"
      strokeWidth="3.6"
    />
    <circle cx="153" cy="160" r="6" stroke="#FFBE00" strokeWidth="2" />
  </svg>
);

const mapState = state => {
  const {authentication} = state;

  return {authentication};
};

export default connect(mapState, {})(NoProducts);
